import { styled } from 'styled-components';

export const ThreeSixtyViewOuterContainer = styled.div`
  touch-action: pan-y pinch-zoom;
  padding-top: 2.75rem;
  @media screen and (min-width: 769px) {
    padding: 0;
  }

  .video-controls,
  .playhead,
  .progress,
  .timeline {
    user-select: none;
    touch-action: pan-y pinch-zoom;
  }

  &:hover .video-controls,
  .video-controls:hover {
    visibility: visible;
  }

  .video-controls {
    position: absolute;
    bottom: 1.75rem;
    left: 2rem;
    width: calc(100% - 6rem);
    padding: 0;
    box-sizing: border-box;
    z-index: 11;
    visibility: visible;
    padding: 8px;
    margin: -8px;
    touch-action: pan-y pinch-zoom;
    &:hover {
      visibility: visible;
    }

    @media screen and (min-width: 769px) {
      left: 5rem;
      bottom: 2.2rem;
      width: calc(100% - 11rem);
      visibility: hidden;
      .video-controls:hover {
        visibility: visible;
      }
    }

    .timeline {
      position: relative;
      height: 5px;
      background-color: rgba(0, 0, 0, 0.15);
      cursor: pointer;
      border-radius: 100px;

      .progress {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: transparent;
      }

      .playhead {
        position: absolute;
        top: 0;
        left: 0;
        width: 32px;
        height: 32px;
        transform: translate(-50%, -42.1875%);
        background-color: transparent;
      }

      .playhead-icon {
        width: 16px;
        height: 16px;
        background-color: #666666;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .video-pause-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 12;
    background-color: rgba(0, 0, 0, 0.45);

    justify-content: center;
    align-items: center;
  }
`;

export const ThreeSixtyViewContainer = styled.div`
  position: relative;
`;

export const ThreeSixtyPauseOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  display: flex;

  justify-content: center;
  align-items: center;
`;
